module.exports = __webpack_public_path__ + "static/img/975_phase_function_Paper_PointsHejduk_Prediction.05e718b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/975_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 5S1H
// module chunks = 0